//@ts-check
import React from 'react';
import useProvider from '../../core/EcrionProvider/useProvider';
import crossDocumentProtocol from './crossDocumentProtocol';

var useIframeHostProvider = function useIframeHostProvider() {
  var eProps = useProvider();
  React.useEffect(function () {
    crossDocumentProtocol.on(window, 'GetProviderProps', function () {
      var iframes = window.document.getElementsByTagName('iframe'); //window.frames

      for (var i = 0; i < iframes.length; i++) {
        var iframeWindow = iframes[i].contentWindow;
        crossDocumentProtocol.send(iframeWindow, 'GetProviderPropsResponse', {
          microservice: eProps.microservice,
          extensions: eProps.extensions
        });
      }
    });
    return function () {
      crossDocumentProtocol.off(window, 'GetProviderProps');
    };
  }, [eProps]);
};

var IframeHost = function IframeHost() {
  useIframeHostProvider();
  return null;
};

export default IframeHost;